import React from 'react'
import { Link } from 'react-router-dom'
import { serializeSearchQuery, getQueryParamsFromDeptNavLink } from '#src/services/search'
import { useNavItemContext } from '../../TopLevelNavItem/NavItemContext'
import { DepartmentNavigationSubSectionFragment } from '#src/components/Header/NavHierarchyFragments.generated'
import keyBy from 'lodash/keyBy'
import styles from './styles.css'

interface SubSectionItemsProps {
  subSections: DepartmentNavigationSubSectionFragment[]
  topLevelId: string
}

const SubSectionItems: React.FC<SubSectionItemsProps> = ({ subSections, topLevelId }) => {
  const navItemContext = useNavItemContext()

  // We consider tablet as a 'fullSize' resolution
  const filteredSubSections = subSections.filter(subSection => subSection.showIfFullSize)

  return (
    <div className={styles.subSection}>
      {filteredSubSections.map(subSection => {
        if (subSection.titleLink) {
          const queryParams = getQueryParamsFromDeptNavLink(subSection.titleLink)
          const linkLocation =
            queryParams &&
            serializeSearchQuery({
              categorySlug: queryParams.categorySlug,
              selections: queryParams.facets ? keyBy(queryParams.facets, 'name') : undefined,
              filters: queryParams.filters,
              entryPoint: 'nav-browse'
            })
          const linkTarget = {
            pathname: linkLocation?.pathname,
            search: linkLocation?.searchParams.toString()
          }

          return (
            <Link
              key={subSection.id}
              to={{
                pathname: linkTarget?.pathname,
                search: linkTarget?.search
              }}
              onClick={() => navItemContext?.onNavItemSelected()}
              className={styles.item}
            >
              <div className={styles.itemHighlight}>
                <div className={styles.itemHighlightLabel}>{subSection.title}</div>
              </div>
            </Link>
          )
        } else if (
          subSection.__typename === 'DepartmentNavigationListSubSection' &&
          subSection.items.length > 0
        ) {
          return (
            <React.Fragment key={`tablet${topLevelId}${subSection.id}`}>
              {subSection.items.map(subSectionItem => {
                const queryParams = getQueryParamsFromDeptNavLink(subSectionItem.link)
                const linkLocation =
                  queryParams &&
                  serializeSearchQuery({
                    categorySlug: queryParams.categorySlug,
                    selections: queryParams.facets ? keyBy(queryParams.facets, 'name') : undefined,
                    filters: queryParams.filters,
                    entryPoint: 'nav-browse'
                  })
                const linkTarget = {
                  pathname: linkLocation?.pathname,
                  search: linkLocation?.searchParams.toString()
                }

                return (
                  <Link
                    key={`tablet${subSectionItem.label}${subSection.title}`}
                    to={{
                      pathname: linkTarget?.pathname,
                      search: linkTarget?.search
                    }}
                    onClick={() => navItemContext?.onNavItemSelected()}
                    className={styles.item}
                  >
                    <div className={styles.itemHighlight}>
                      <div className={styles.itemHighlightLabel}>{subSectionItem.label}</div>
                    </div>
                  </Link>
                )
              })}
            </React.Fragment>
          )
        }
      })}
    </div>
  )
}

export default SubSectionItems
